import { AT } from '../../actions/actionTypes';
import { DialogState, PanelsType, ModalsType } from './model';
import { StateDefault } from './deviceInfo/defaults';
import DeviceInfoReducer from './deviceInfo/reducer';
import * as Transfers from './transfer';
import TransfersReducer from './transfer/reducer';
import * as ReadRights from './readRights';
import ReadRightsReducer from './readRights/reducer';
import * as Download from './download';
import DownloadReducer from './download/reducer';
import * as Register from './register';
import RegisterReducer from './register/reducer';
import * as DownloadLogs from './downloadLogs';
import DownloadLogsReducer from './downloadLogs/reducer';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const defaultState: DialogState = {
  activeDialog: '',
  activeModal: '',
  deviceInfoDialog: StateDefault,
  transferState: Transfers.StateDefault,
  readrightState: ReadRights.StateDefault,
  downloadState: Download.StateDefault,
  downloadLogsState: DownloadLogs.StateDefault,
  registerState: Register.StateDefault,
};

export default function (state = defaultState, action: any) {
  const stateAfterDialogs = {
    ...state,
    deviceInfoDialog: DeviceInfoReducer(state.deviceInfoDialog, action),
    transferState: TransfersReducer(state.transferState, action),
    readrightState: ReadRightsReducer(state.readrightState, action),
    downloadState: DownloadReducer(state.downloadState, action),
    downloadLogsState: DownloadLogsReducer(state.downloadLogsState, action),
    registerState: RegisterReducer(state.registerState, action),
  };
  switch (action.type) {
    case AT.DIALOG_ACTIVE_CHANGED: {
      Logger.info([AT.DIALOG_ACTIVE_CHANGED, action], LogArea.Redux);
      const activeDialog: PanelsType = action.payload;
      return { ...stateAfterDialogs, activeDialog };
    }
    case AT.MODAL_ACTIVE_CHANGED: {
      Logger.info([AT.MODAL_ACTIVE_CHANGED, action], LogArea.Redux);
      const activeModal: ModalsType = action.payload;
      return { ...stateAfterDialogs, activeModal };
    }

    case AT.DEVICES.ACTIVATE_SUCCESS:
    case AT.DEVICES.REMOVE_SUCCESS:
    case AT.DIALOG_READRIGHTS_ASSIGN_SUCCESS:
    case AT.DIALOG_READRIGHTS_REMOVE_SUCCESS: {
      const activeModal: ModalsType = '';
      return { ...stateAfterDialogs, activeModal };
    }

    default: {
      return stateAfterDialogs;
    }
  }
}
